import { AutoComplete } from 'primereact/autocomplete'
import { useEffect, useState } from 'react'

import { Flex } from '../../../../Components'
import { cap } from '../../../../State'
import { getColorDiff } from './Functions'
import { useTransferField } from './Hook'

const language = (cap.language.state || 'it').toLowerCase()

export const AirportInput = ({ state: [state, setState], item, count, readOnly, diffStatus }) => {
  const { location, label, id, options, notRequired = false, limitLength } = item
  const [iataCode, setIataCode] = useTransferField([state, setState], location?.value, count)
  const [iataCodeErr, setIataCodeErr] = useState(false)
  const [, setAirportDesc] = useTransferField([state, setState], location?.label, count)
  const onSelect = ({ label, value }) => {
    setIataCode(value)
    setAirportDesc(label)
  }
  const [suggestionsIataCode, setSuggestionsIataCode] = useState([])
  const maxLength = limitLength && limitLength > 0 ? limitLength : undefined

  useEffect(() => {
    setIataCodeErr(
      (!iataCode && !notRequired) || (iataCode && !options?.find(({ value }) => value === iataCode))
    )
  }, [iataCode])

  const searchIataCode = (event) => {
    if (!event.query.trim().length) setSuggestionsIataCode([...options])
    else {
      setSuggestionsIataCode([
        ...options.filter(({ value }) => value.toLowerCase().startsWith(event.query.toLowerCase())),
        ...options.filter(({ label }) => label.toLowerCase().includes(event.query.toLowerCase()))
      ])
    }
  }

  return (
    <Flex key={item.id + '1'} as js style={{ width: '23%', margin: '5px 1%' }}>
      <div className="nfield" style={{ marginTop: 25, width: '100%' }}>
        <span className="p-float-label">
          <AutoComplete
            disabled={readOnly}
            field="value"
            className={iataCodeErr ? 'p-invalid' : ''}
            id={id}
            onSelect={(e) => onSelect(e.value)}
            style={{ width: '100%' }}
            value={iataCode}
            suggestions={suggestionsIataCode}
            completeMethod={searchIataCode}
            onChange={(e) => {
              setIataCode(e.value)
              setAirportDesc('')
            }}
            inputStyle={{
              fontFamily: 'var(--font-family)',
              fontSize: 14,
              width: '100%',
              color: getColorDiff(diffStatus, iataCodeErr)
            }}
            forceSelection
            itemTemplate={({ both = '' }) => both}
            inputProps={{ maxLength }}
          />
          <label
            style={{
              fontFamily: 'var(--font-family)',
              color: getColorDiff(diffStatus, iataCodeErr)
            }}
          >
            {label?.value?.[language] || label?.value?.it}
          </label>
        </span>
      </div>
    </Flex>
  )
}
